module.exports = __webpack_public_path__ + "static/media/mickey3_portuguese_1.386cba98.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mickey3_portuguese_1.png
// module id = 157
// module chunks = 0